var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app", attrs: { id: "app" } }, [
    _c(
      "div",
      {
        class: {
          "app-container": true,
          "no-nav": _vm.showNavs(),
          "no-footer": _vm.showNavs()
        }
      },
      [
        _c("Notification"),
        _vm._v(" "),
        _c("Navigation"),
        _vm._v(" "),
        _c("ModalBox"),
        _vm._v(" "),
        _c("router-view")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cfb0ee2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfb0ee2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/App/App.vue
// module id = null
// module chunks = 